import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { api } from '../../../auth'
import { fetchKbArticle } from '../api/knowledgeBaseApi'
import type { KbArticleDetail } from '../types'
import ArticleView from '../components/ArticleView'
import KBSkeleton from '../components/KBSkeleton'

interface ArticlePageProps {
    onGoHome: () => void
    onSelectArticle: (slug: string) => void
}

const ArticlePage = ({ onGoHome, onSelectArticle }: ArticlePageProps) => {
    const { slug } = useParams<{ slug: string }>()
    const navigate = useNavigate()
    const axiosPrivate = api
    const [data, setData] = useState<KbArticleDetail | null>(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (!slug) return
        let cancelled = false
        setLoading(true)
        setData(null)
        fetchKbArticle(axiosPrivate, slug)
            .then((res) => {
                if (!cancelled) setData(res)
            })
            .catch(() => {})
            .finally(() => {
                if (!cancelled) setLoading(false)
            })
        return () => {
            cancelled = true
        }
    }, [axiosPrivate, slug])

    const goBackToCategory = () => {
        if (data?.category?.slug) {
            navigate(`/help/category/${data.category.slug}`)
        } else {
            onGoHome()
        }
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    if (loading || !data) {
        return (
            <div className="kb-container">
                <KBSkeleton variant="article" />
            </div>
        )
    }

    return (
        <div className="kb-container">
            <ArticleView
                article={data}
                onBack={goBackToCategory}
                onGoHome={onGoHome}
                onSelectArticle={onSelectArticle}
            />
        </div>
    )
}

export default ArticlePage
